// Shared (client+server safe) referral helpers.

export const REFERRAL_COUPON_ID = "knowmeno_referral_v1";
export const REFERRAL_COUPON_NAME = "KnowMeno Referral — 1 Free Month";
export const REFERRAL_COUPON_AMOUNT_OFF = 1499; // $14.99 in cents
export const REFERRAL_CAP_PER_YEAR = 12;
export const REFERRAL_CAP_WINDOW_DAYS = 365;

export function shareUrlForCode(code: string, origin?: string): string {
  const base = origin || "https://knowmeno.com";
  return `${base}/?ref=${encodeURIComponent(code)}`;
}

export function shareTextForCode(code: string, origin?: string): string {
  const url = shareUrlForCode(code, origin);
  return `I've been using KnowMeno to track my menopause symptoms and bring real data to my doctor 💜 Try it free for 7 days — and if you subscribe, we both get a free month. ${url}`;
}

export function isValidReferralCode(code: string | null | undefined): boolean {
  if (!code) return false;
  return /^[A-HJ-NP-Z2-9]{8}$/.test(code);
}
